import { SupportCasesItem } from '../../../../types';
import { Link } from 'react-router-dom';
import { Icon } from '../../../Atoms/Icon';
import { getMetaData } from '../../DetailsDrawer/detailsDrawersHelpers';

export type CaseLinkProps = {
  data: SupportCasesItem;
  classNames?: string;
};

export function CaseLink({ classNames, data }: CaseLinkProps) {
  return (
    <Link
      state={{
        data,
        ...getMetaData('support')
      }}
      className={classNames || 'flex items-center absolute justify-center h-full ml-[7px]'}
      title="Open Case"
      to={`/support-cases/${data.id}?detailId=${data.id}`}>
      <Icon
        type="details"
        className="p-3 ml-auto cursor-pointer"
      />
    </Link>
  );
}
